export class HTHGameConfig {
    public static reelsNum: number = 6;
    public static symbolsNumOnReel: number = 6;
    public static reelHeight: number = 624;
    public static symbolHeight: number = 150;
    public static symbolWidth: number = 120;
    public static defaultGameAreaSize: number[] = [4, 3, 3, 3, 3, 4];
    public static reelAreaPos: PIXI.Point = new PIXI.Point(60, 150);
    public static reelAreaMaskPos: PIXI.Point = new PIXI.Point(0, 0);
    public static reelPositions: PIXI.Point[] = [
        new PIXI.Point(0, 0),
        new PIXI.Point(0 + HTHGameConfig.symbolWidth, 0),
        new PIXI.Point(0 + HTHGameConfig.symbolWidth * 2, 0),
        new PIXI.Point(0 + HTHGameConfig.symbolWidth * 3, 0),
        new PIXI.Point(0 + HTHGameConfig.symbolWidth * 4, 0),
        new PIXI.Point(0 + HTHGameConfig.symbolWidth * 5, 0),
        new PIXI.Point(0 + HTHGameConfig.symbolWidth * 6, 0)
    ];
    public static enhancerPositions: number[][] = [[1, 3], [2, 3], [4, 3], [5, 3]];
    public static scatterNumOnReels: number[] = [0, 0, 0, 0, 0, 0];
    public static scatterCount:number =0;
    public static isAnticipationPlaying: boolean = false;
    public static bigWinLevelPlayed:boolean[]=[false,false,false,false,false];
    public static lastBigWinPlayedAmount:number=0;
    public static isBigWinLevel5Played:boolean;
    public static isSkipped: boolean[] = [false,false];
}

